module.exports = __webpack_public_path__ + "static/media/paise.d5dd69d8.gif";